import React, { useEffect, useState } from 'react';
import { getCountries, createCountry, updateCountry } from '../api/admin';

// System > Countries & Settings — Owner self-service: "Create, prepare,
// activate, pause, reorder countries; update currency and time zone."
const CountriesSettings = () => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ country_code: '', country_name: '', currency: '', timezone: '' });
  const [error, setError] = useState('');

  const load = () => { setLoading(true); getCountries().then((res) => setCountries(res.data?.countries || [])).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await createCountry(form);
      setForm({ country_code: '', country_name: '', currency: '', timezone: '' });
      setShowForm(false);
      load();
    } catch (err) {
      setError(err.response?.data?.error || 'Could not create country.');
    }
  };

  const setStatus = async (code, status) => { await updateCountry(code, { status }); load(); };
  const move = async (c, direction) => { await updateCountry(c.country_code, { sort_order: (c.sort_order || 0) + direction }); load(); };

  return (
    <div style={s.page}>
      <h1 style={s.h1}>Countries & Settings</h1>
      <p style={s.hint}>New country starts as "Draft" — switch to "Active" when ready to go live. "Paused" hides it without losing its data.</p>

      <button style={s.newBtn} onClick={() => setShowForm((v) => !v)}>{showForm ? 'Cancel' : '+ New country'}</button>

      {showForm && (
        <form onSubmit={create} style={s.form}>
          <input style={s.input} placeholder="Country code (e.g. DE)" value={form.country_code} onChange={(e) => setForm((f) => ({ ...f, country_code: e.target.value.toUpperCase() }))} maxLength={2} required />
          <input style={s.input} placeholder="Country name (e.g. Germany)" value={form.country_name} onChange={(e) => setForm((f) => ({ ...f, country_name: e.target.value }))} required />
          <input style={s.input} placeholder="Currency (e.g. EUR)" value={form.currency} onChange={(e) => setForm((f) => ({ ...f, currency: e.target.value.toUpperCase() }))} maxLength={3} />
          <input style={s.input} placeholder="Time zone (e.g. Europe/Berlin)" value={form.timezone} onChange={(e) => setForm((f) => ({ ...f, timezone: e.target.value }))} />
          {error && <div style={s.error}>{error}</div>}
          <button type="submit" style={s.saveBtn}>Create (as Draft)</button>
        </form>
      )}

      {loading ? <p>Loading…</p> : (
        <table style={s.table}>
          <thead><tr><th style={s.th}>Order</th><th style={s.th}>Country</th><th style={s.th}>Currency</th><th style={s.th}>Time zone</th><th style={s.th}>Status</th><th style={s.th}>Actions</th></tr></thead>
          <tbody>
            {countries.map((c) => (
              <tr key={c.country_code}>
                <td style={s.td}>
                  <button style={s.btnGray} onClick={() => move(c, -1)}>↑</button>
                  <button style={s.btnGray} onClick={() => move(c, 1)}>↓</button>
                </td>
                <td style={s.td}>{c.country_name} ({c.country_code})</td>
                <td style={s.td}>{c.currency || '—'}</td>
                <td style={s.td}>{c.timezone || '—'}</td>
                <td style={s.td}><span style={s.badge}>{c.status}</span></td>
                <td style={s.td}>
                  {c.status !== 'active' && <button style={s.btnGreen} onClick={() => setStatus(c.country_code, 'active')}>Activate</button>}
                  {c.status === 'active' && <button style={s.btnGray} onClick={() => setStatus(c.country_code, 'paused')}>Pause</button>}
                  {c.status !== 'archived' && <button style={s.btnRed} onClick={() => setStatus(c.country_code, 'archived')}>Archive</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

const s = {
  page: { padding: 24, maxWidth: 900 },
  h1: { fontSize: 22, fontWeight: 800, marginBottom: 8 },
  hint: { color: '#6b7280', fontSize: 13, marginBottom: 16 },
  newBtn: { padding: '8px 16px', borderRadius: 8, border: 'none', background: '#0B6A4A', color: 'white', fontWeight: 700, fontSize: 13, cursor: 'pointer', marginBottom: 16 },
  form: { background: 'white', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16, marginBottom: 20, display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 360 },
  input: { padding: '8px 10px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13 },
  error: { color: '#b91c1c', fontSize: 12.5 },
  saveBtn: { padding: '9px', borderRadius: 8, border: 'none', background: '#0B6A4A', color: 'white', fontWeight: 700, fontSize: 13, cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse', background: 'white', fontSize: 13 },
  th: { textAlign: 'left', padding: '8px 10px', borderBottom: '2px solid #e5e7eb', color: '#6b7280', fontSize: 12 },
  td: { padding: '8px 10px', borderBottom: '1px solid #f3f4f6' },
  badge: { padding: '3px 8px', borderRadius: 999, background: '#f3f4f6', fontSize: 11, fontWeight: 700 },
  btnGreen: { padding: '5px 10px', marginRight: 4, borderRadius: 6, border: 'none', background: '#16a34a', color: 'white', cursor: 'pointer', fontSize: 12 },
  btnRed: { padding: '5px 10px', marginRight: 4, borderRadius: 6, border: 'none', background: '#dc2626', color: 'white', cursor: 'pointer', fontSize: 12 },
  btnGray: { padding: '5px 10px', marginRight: 4, borderRadius: 6, border: '1px solid #d1d5db', background: 'white', color: '#374151', cursor: 'pointer', fontSize: 12 },
};

export default CountriesSettings;
